import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../assets/TopicPage.css";

// Application Info (2026-10-22 spec): one centered "Application Info" button.
// Clicking it opens a bounded box with two buttons spread across its width,
// Data collected and Data NOT collected, and no content. Clicking either shows
// its text below, as wide as the box (toggle: click again to hide). Clicking
// Application Info again collapses everything. The section is a full-width
// block, so opening it never re-centres the form above it.
const InfoToggles = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [topic, setTopic] = useState(null);
    const toggleAll = () => { setOpen((o) => !o); setTopic(null); };
    const toggleTopic = (key) => setTopic((cur) => (cur === key ? null : key));

    return (
        <section className="appinfo" aria-label={t("info.heading")}>
            <div className="appinfo__header">
                <button type="button" id="appinfo-toggle" className={"appinfo__main" + (open ? " appinfo__main--open" : "")} aria-expanded={open} aria-controls="appinfo-box" onClick={toggleAll}>
                    {t("info.heading")}
                </button>
            </div>
            {open && (
                <div id="appinfo-box" className="appinfo__box">
                    <div className="appinfo__buttons">
                        <button type="button" id="appinfo-collected" className={"appinfo__topic" + (topic === "collected" ? " appinfo__topic--active" : "")} aria-expanded={topic === "collected"} aria-controls="appinfo-panel" onClick={() => toggleTopic("collected")}>
                            {t("info.collectedButton")}
                        </button>
                        <button type="button" id="appinfo-not-collected" className={"appinfo__topic" + (topic === "not-collected" ? " appinfo__topic--active" : "")} aria-expanded={topic === "not-collected"} aria-controls="appinfo-panel" onClick={() => toggleTopic("not-collected")}>
                            {t("info.notCollectedButton")}
                        </button>
                    </div>
                    {topic && (
                        <div id="appinfo-panel" className="appinfo__panel">
                            {topic === "collected" ? (
                                <ul className="topic-list">
                                    <li>{t("info.dc1")}</li>
                                    <li>{t("info.dcForwarded")}</li>
                                    <li>{t("info.dcMedia")}</li>
                                    <li>{t("info.dc3")}</li>
                                    <li>{t("info.dcChannels")}</li>
                                    <li className="topic-list__highlight">
                                        <strong>{t("info.dcProtected")}</strong>
                                        <ul>
                                            <li>{t("info.dcP1")}</li>
                                            <li>{t("info.dcP2")}</li>
                                            <li>{t("info.dcP3")}</li>
                                        </ul>
                                    </li>
                                </ul>
                            ) : (
                                <ul className="topic-list">
                                    <li>{t("info.nc1")}</li>
                                    <li>{t("info.nc2")}</li>
                                    <li>{t("info.nc3")}</li>
                                    <li>{t("info.nc4")}</li>
                                </ul>
                            )}
                        </div>
                    )}
                </div>
            )}
        </section>
    );
};

export default InfoToggles;
